import { fetcher } from '../utils'
import { FlowVO } from '@repo/types'

export default async (connectionKey: string): Promise<FlowVO[]> =>
  fetcher(`/api/chats/${connectionKey}/flows`, 'GET', undefined)
